import { Box, type BoxProps } from '@chakra-ui/react';

type Elevation = 'flat' | 'raised' | 'inset';

const LAYER: Record<Elevation, string> = {
	flat: 'card',
	raised: 'card.raised',
	inset: 'card.inset',
};

export interface PanelProps extends BoxProps {
	/** Where the panel sits relative to the page: in it, above it, or recessed into it. */
	elevation?: Elevation;
}

/**
 * A bordered surface — the box that holds a group of content.
 *
 * The styling is the `card` layer style; this is the discoverable way to reach it. A prop spelled
 * at a call site is found by grep and nothing else, while a component turns up in autocomplete and
 * answers find-references — which is what decides whether an abstraction gets used by the next
 * person shipping a feature rather than only by the person who wrote it.
 *
 * It covers the plain-box case only. A surface that is already a `Dialog.Content`, a `Menu.Item` or
 * a `Card.Root` keeps its own element and takes `layerStyle="card"` directly — the layer style
 * composes onto anything, which is why it stays the underlying mechanism.
 */
export const Panel = ({ elevation = 'flat', ...props }: PanelProps) => <Box layerStyle={LAYER[elevation]} {...props} />;
